const VALID_VIEWS = new Set(["board", "hand", "duo"]);

export function normalizeRequestedView(requestedView = "board") {
  return VALID_VIEWS.has(requestedView) ? requestedView : "board";
}

// A seat wins over owning the lobby. In party mode the two never coincide — the host
// screen is filtered out of the players — so this only decides anything in a 2 mot 2,
// where the phone that created the lobby is also one of the four playing on it.
export function resolveGameView({ requestedView = "board", isHost = false, hasPlayer = false } = {}) {
  if (hasPlayer) return "hand";
  if (isHost) return "board";
  return normalizeRequestedView(requestedView);
}
